import { get } from 'lodash';
import { FieldName, Fields } from '@zapier/payment/src/types';

type ChangeOptions = {
  ignoreWhitespace?: boolean;
};

export const getValue = (
  name: FieldName,
  fields: Fields // input tags don't like having `null` in it's `value` prop so make sure we default to `''`
) => get(fields, [name, 'value']) || '';

export const handleChange = (
  onChange: (name: FieldName, value: string) => void,
  name: FieldName,
  options: ChangeOptions = {}
  // Handles a React change event, a change event from StateSelect (omits USState type), or just a plain string
) => (event: (React.ChangeEvent | { code: string }) | string) => {
  let value =
    typeof event === 'string'
      ? event
      : get(event, 'target')
      ? get(event, ['target', 'value'])
      : get(event, 'code', '');

  if (options.ignoreWhitespace) {
    value = value.replace(/\s+/g, '');
  }

  return onChange(name, value);
};

export const hasError = (name: FieldName, fields: Fields) => {
  const error = get(fields, [name, 'error']);
  return error && !error.isFixed;
};
